export const getRatingColor = (rating: number) => {
  if (rating <= 2) return '#D04040';
  if (rating === 3) return '#E5A52B';
  return '#37BB90';
};
